export enum PostStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Published = 'published',
  Declined = 'declined',
  Scheduled = 'scheduled',
}

export const isPublishedPostStatus = (status: PostStatusEnum): boolean =>
  status === PostStatusEnum.Published || status === PostStatusEnum.Approved
